/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_P1Inputs */

const tr_mesafeli_s12_p1 = /** @type {(inputs: Mesafeli_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı aşağıdaki hizmet seviyelerini en iyi çaba temelinde hedefler:`)
};

const en_mesafeli_s12_p1 = /** @type {(inputs: Mesafeli_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider targets the following service levels on a best effort basis:`)
};

const de_mesafeli_s12_p1 = /** @type {(inputs: Mesafeli_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter strebt die folgenden Servicelevel auf Basis bestmöglicher Bemühungen an:`)
};

const ru_mesafeli_s12_p1 = /** @type {(inputs: Mesafeli_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик стремится обеспечить следующие уровни обслуживания на основе принципа наилучших усилий:`)
};

/**
* | output |
* | --- |
* | "The Provider targets the following service levels on a best effort basis:" |
*
* @param {Mesafeli_S12_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_p1 = /** @type {((inputs?: Mesafeli_S12_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_p1(inputs)
	if (locale === "de") return de_mesafeli_s12_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s12_p1(inputs)
	return tr_mesafeli_s12_p1(inputs)
});